<template>
  <el-drawer
    :title="title"
    :append-to-body="appendToBoddy"
    :visible.sync="drawer_visible"
    direction="rtl"
    size="70%"
  >
    <iframe width="100%" height="100%" :src="url"></iframe>
  </el-drawer>
</template>

<script>
export default {
  name: "CustAccountStatus",
  props: {
    appendToBoddy: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  components: {},
  data() {
    return {
      loading: false,
      drawer_visible: false,
      title: "",
      url: ""
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    callNew(urlsrc) {
      this.title = "Factura";
      this.url = urlsrc;
      this.drawer_visible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
